import { logFloodgateActivity } from '../actions/publicActions';
import {
    default as loadAndInitializeFloodgateEngine,
    InitParam,
} from '../utils/loadAndInitializeFloodgateEngine';
import { orchestrator } from 'satcheljs';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getUserConfiguration } from 'owa-session-store';
import {
    isInAnyInboxPlusExperiment,
    isInAnyInboxPlusTreatment,
    isInEasyOnExperiment,
} from 'owa-inbox-plus-util/lib/util/inboxPlusFlightUtil';

export default orchestrator(logFloodgateActivity, async actionMessage => {
    const initParam: InitParam = {
        SearchTraceId: actionMessage.searchTraceId,
        Flights: getFloodgateFlights(), // Add interested flights. Floodgate Survey doesn't allow null here.
    };

    // Make sure the engine is loaded. If loaded, this is a no-op
    await loadAndInitializeFloodgateEngine(initParam);

    // Then log the activity
    if (window.OfficeBrowserFeedback && window.OfficeBrowserFeedback.floodgate) {
        const floodGateEngine = window.OfficeBrowserFeedback.floodgate.getEngine();
        if (floodGateEngine) {
            floodGateEngine.getActivityListener().logActivity(actionMessage.activityType);
        }
    }
});

function getFloodgateFlights(): string {
    let floodgateFlights: string = '';

    if (isFeatureEnabled('doc-SxS-jsApi-ODB-Base')) {
        floodgateFlights += 'JsApi;';
    } else if (isFeatureEnabled('doc-SxS-jsApi-ODB-BaseNoEditString')) {
        floodgateFlights += 'WacNoEditString;';
    } else if (isFeatureEnabled('doc-SxS-jsApi-ODB-Readonly')) {
        floodgateFlights += 'WacReadonly;';
    } else {
        floodgateFlights += 'LegacyWac;';
    }

    if (isInAnyInboxPlusExperiment()) {
        floodgateFlights += 'InboxPlusSession';

        if (isInEasyOnExperiment()) {
            floodgateFlights += 'EasyOn';
        }
        floodgateFlights += isFocusedInboxEnabled() ? 'FocusedOther' : 'Inbox';
        floodgateFlights += isInAnyInboxPlusTreatment() ? 'Treatment;' : 'Control;';
    }

    return floodgateFlights;
}

// Gets if Focused Inbox feature is enabled for the user
function isFocusedInboxEnabled(): boolean {
    return (
        getUserConfiguration().UserOptions.IsFocusedInboxFeatureSupported &&
        getUserConfiguration().UserOptions.IsFocusedInboxEnabled
    );
}
